/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lg_Guest_NoteInputs */

const en_lg_guest_note = /** @type {(inputs: Lg_Guest_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A visit does not grant access to workspace chat, documents, saved transcripts, or recordings. Guests in a call see chat only from when they joined during that visit.`)
};

const id_lg_guest_note = /** @type {(inputs: Lg_Guest_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunjungan tidak memberi akses ke chat workspace, dokumen, transkrip, atau rekaman tersimpan. Tamu dalam panggilan hanya melihat chat sejak bergabung pada kunjungan tersebut.`)
};

/**
* | output |
* | --- |
* | "A visit does not grant access to workspace chat, documents, saved transcripts, or recordings. Guests in a call see chat only from when they joined during tha..." |
*
* @param {Lg_Guest_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const lg_guest_note = /** @type {((inputs?: Lg_Guest_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lg_Guest_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_lg_guest_note(inputs)
	return en_lg_guest_note(inputs)
});